<div class="modal-container">
  <div class="modal-header">
    <h5 class="header-title">{{ title }}</h5>
    <!-- <button type="button" class="" (click)="close()" data-dismiss="modal">
      <span class='ti ti-close'></span>
    </button> -->
  </div>

  <div class="modal-body">
    <!-- <h6 class="body-title"></h6> -->
    <p [innerHTML]="content"></p>
  </div>

  <div class="modal-footer">
    <button *ngIf="closeBtnName" class="btn-secondary" (click)="onDismiss()">{{ closeBtnName }}</button>
    <button class="btn-main" (click)="onSubmit()">{{ acceptBtnName }}</button>
  </div>
</div>
